import { focusElement } from 'platform/utilities/ui';
import { useEffect } from 'react';

/**
 * Sets focus on a heading when the component mounts, providing an
 * accessible starting point after navigation.
 *
 * @param {string} [selector='[data-testid="form-title"]'] - CSS selector for the heading to focus.
 */
export const useHeadingFocus = (selector = '[data-testid="form-title"]') => {
  useEffect(() => focusElement(selector), [selector]);
};
